import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AvailableComponent } from './available/available.component';

import { BadgesComponent } from './badges.component';
import { CampaignComponent } from './campaign/campaign.component';
import { EarnedComponent } from './earned/earned.component';
import { LeaderComponent } from './leader/leader.component';

const routes: Routes = [
  {
    path: '',
    component: BadgesComponent,
    children: [
      {
        path: 'earned',
        component: EarnedComponent
      },
      {
        path: 'available',
        component: AvailableComponent
      },
      {
        path: 'leader',
        component: LeaderComponent
      },
      {
        path: 'campaign',
        component: CampaignComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BadgesRoutingModule {}
